module.exports = __webpack_public_path__ + "img/detail-extend-icon.bf6eb37c.png";